export { default as LifestylesTypesFilterBadge } from './LifestylesTypesFilterBadge';
